/* eslint-disable react/no-multi-comp */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useTranslation } from 'react-i18next';
import Button from './Button';

interface Props {
  color?: string;
  title?: string;
  message: string;
  icon?: IconProp;
  buttonAction?: Action;
  secondButtonAction?: Action;
  reportLink?: string;
}

interface Action {
  text: string;
  action: () => void;
}

const Basic: React.FC<Props> = ({
  color = '',
  title = '',
  message,
  icon,
  buttonAction,
  secondButtonAction,
  reportLink,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`notification notification--${color} d-flex`}>
      <div className="notification__content w-100">
        {icon && (
          <div className="notification__icon">
            <FontAwesomeIcon icon={icon} />
          </div>
        )}
        <h5 className="notification__title bold-text">{title}</h5>
        {message && <p className="notification__message">{message}</p>}
        {reportLink && (
          <p>
            {t('Do you want to report this issue? Please, ')}
            <a href={reportLink} target="_blank" rel="noopener noreferrer">
              {t('click here')}
            </a>
            .
          </p>
        )}
      </div>
      {buttonAction && (
        <div className="notification__action text-nowrap float-right">
          <Button text={buttonAction.text} onClick={buttonAction.action} className="btn-tertiary" />
        </div>
      )}
      {secondButtonAction && (
        <div className="notification__action text-nowrap float-right">
          <Button
            text={secondButtonAction.text}
            onClick={secondButtonAction.action}
            className="btn-tertiary"
          />
        </div>
      )}
    </div>
  );
};

interface FullWideProps {
  color?: string;
  title?: string;
  message: string;
}

const FullWide: React.FC<FullWideProps> = ({ color = '', title = '', message }) => (
  <div className={`notification notification--full-wide notification--${color}`}>
    {title && <h5 className="notification__title bold-text">{title}</h5>}
    <p className="notification__message">{message}</p>
  </div>
);

export const BasicNotification = React.memo(Basic);
export const FullWideNotification = React.memo(FullWide);
